<template>
    <div id="app">
        <!-- 内容 Start -->
        <router-view></router-view>
        <!-- 内容 End -->
        <indexRight></indexRight>
    </div>
</template>

<script>
require('es6-promise').polyfill();
import indexRight from './components/right'

export default {
    name: 'app',
    components: {
        indexRight
    },
    data(){
        return{
        }
    },
    mounted:function(){
        var _hmt = _hmt || [];
        (function() {
          var hm = document.createElement("script");
          hm.src = "https://hm.baidu.com/hm.js?5c97eea3efb2348dc1eea821ea799969";
          var s = document.getElementsByTagName("script")[0]; 
          s.parentNode.insertBefore(hm, s);
        })();
    },
    methods:{
        //获取浏览器默认语言
        /*getLanguage:function(){
            let that=this;
            if(navigator.language=="zh-CN"){
                that.$i18n.locale="zh";
            }else if(navigator.language=="ru"){
                that.$i18n.locale="ru";
            }else{
                that.$i18n.locale="en";
            }
        },*/
        //加载语言
        /*loadLang:function(indexLang){
            let that=this;
            if(indexLang=="zh"){
                indexLang="中文";
            }else if(indexLang=="en"){
                indexLang="英文";
            }else{
                indexLang="俄文";
            }
            that.$axios({
                method:'get',
                url:that.api+'/bootdo/blog/websit/shouye/changeLang',
                params:{
                    lang:indexLang
                }
            }).then(function(msg){
                //console.log(msg.data);
                if(msg.data.code==100){
                    
                }else{
                    that.getError(msg.data);
                }
            });
        },*/
    }
}
</script>

<style scoped>
@import './assets/css/common.css';
</style>

